import { render } from "./Battery.vue?vue&type=template&id=6cbcf08a&scoped=true"
import script from "./Battery.vue?vue&type=script&lang=js"
export * from "./Battery.vue?vue&type=script&lang=js"

import "./Battery.vue?vue&type=style&index=0&id=6cbcf08a&scoped=true&lang=css"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbcf08a"]])

export default __exports__